import script from "./ViewWord.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWord.vue?vue&type=script&setup=true&lang=js"

import "./ViewWord.vue?vue&type=style&index=0&id=d69fb720&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69fb720"]])

export default __exports__